(function () {
  if (customElements.get('related-products-slider')) return;

  class RelatedProductsSlider extends HTMLElement {
    connectedCallback() {
      if (this.children.length === 0) return;

      this.cleanupBreakpoint = window.SliderSettings.onBreakpointChange(() => {
        this.destroySlider();
        this.createSlider();
      });

      if (typeof Flickity !== 'undefined') {
        this.createSlider();
      } else {
        window.addEventListener('load', () => this.createSlider(), { once: true });
      }
    }

    createSlider() {
      if (typeof Flickity === 'undefined') return;
      const opts = window.getFlickityOptions(this);
      this.flkty = new Flickity(this, opts);
    }

    destroySlider() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }

    disconnectedCallback() {
      this.cleanupBreakpoint?.();
      this.destroySlider();
    }
  }

  customElements.define('related-products-slider', RelatedProductsSlider);
})();
